exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".redux-templates-single-section-item .block-editor-block-preview__container {\n  margin: 0 auto;\n  min-height: 130px; }\n", ""]);

